// extracted by mini-css-extract-plugin
export var actionButton = "_5r-0";
export var attachmentLine = "_5r-1";
export var fileInput = "_5r-2";
export var fileUploadWrapper = "_5r-4";
export var footer = "_5r-3";
export var modalContent = "_5r-5";
export var paperclip = "_5r-6";
export var quillEditor = "_5r-7";